export function gcd(x, y) {
    let i = x;
    for (let j = y; j !== 0;) {
        const t = i;
        i = j;
        j = t % i;
    }
    return i;
}
